var _rect, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStatisticsChecked(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.600098,
    width: 32,
    height: 32,
    rx: 16,
    fill: "#E6F8FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.6003 23.1663C12.6469 23.1663 9.43359 19.953 9.43359 15.9997C9.43359 12.0463 12.6469 8.83301 16.6003 8.83301C20.5536 8.83301 23.7669 12.0463 23.7669 15.9997C23.7669 19.953 20.5536 23.1663 16.6003 23.1663ZM16.6003 9.83301C13.2003 9.83301 10.4336 12.5997 10.4336 15.9997C10.4336 19.3997 13.2003 22.1663 16.6003 22.1663C20.0003 22.1663 22.7669 19.3997 22.7669 15.9997C22.7669 12.5997 20.0003 9.83301 16.6003 9.83301Z",
    fill: "#26B5ED"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6539 18.3863C15.5205 18.3863 15.3939 18.333 15.3005 18.2397L13.4139 16.353C13.2205 16.1597 13.2205 15.8397 13.4139 15.6463C13.6072 15.453 13.9272 15.453 14.1205 15.6463L15.6539 17.1797L19.0805 13.753C19.2739 13.5597 19.5939 13.5597 19.7872 13.753C19.9805 13.9463 19.9805 14.2663 19.7872 14.4597L16.0072 18.2397C15.9139 18.333 15.7872 18.3863 15.6539 18.3863Z",
    fill: "#26B5ED"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatisticsChecked);
export default __webpack_public_path__ + "static/media/statistics-checked.2a8d53f64edd24bc65839b74db727be5.svg";
export { ForwardRef as ReactComponent };